export default "__VITE_ASSET__6baf69fb__"